import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieDisclaimer from "../components/CookieDisclaimer";
import SEO from "../components/SEO";
import "../styles.css";

export default function FollowTheMouse() {
  return (
    <>
      <SEO
        title="Follow The Mouse - Smooth Cursor Follow Script"
        description="Download Follow The Mouse, a professional OBS Studio script that adds smooth zooming and mouse tracking to your screen capture workflow."
        keywords="Follow The Mouse, mouse follow script, cursor follow, OBS Studio, screen recording, mouse tracking"
        url="https://zemaxi.com/tools/follow-the-mouse"
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="trophy-tracker-hero">
          <div className="container">
            <h1>Follow The <span className="highlight">Mouse</span></h1>
            <p>A professional OBS Studio script that adds smooth zooming and mouse tracking to your screen capture workflow.</p>
          </div>
        </section>

        <section className="trophy-tracker-content">
          <div className="container">
            <div className="trophy-tracker-image">
              <img src="https://zemaxi.com/images/products/FollowTheMouse.png" alt="Follow The Mouse Preview" />
            </div>

            <div className="trophy-tracker-description">
              <h2>What is <span className="highlight">Follow The Mouse?</span></h2>
              <p>Follow The Mouse is an OBS Studio script that lets you smoothly zoom into your screen and automatically track your mouse cursor in real time. It’s designed for creators who want a cleaner, more dynamic way to present tutorials, coding sessions, design work, live demos, software walkthroughs, strategy games, and anything else where the viewer needs to clearly follow on-screen movement.</p>
            </div>

            <div className="trophy-tracker-video">
              <h2>Video <span className="highlight">Tutorial</span></h2>
              <div className="video-embed-container">
                <iframe
                  width="840"
                  height="473"
                  src="https://www.youtube.com/embed/MLZtJa-IqQo"
                  title="Follow The Mouse Installation Guide"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="trophy-tracker-cta">
              <h2>Ready to <span className="highlight">Download?</span></h2>
              <div className="cta-buttons">
                <a href="/files/follow-the-mouse.lua" download className="btn btn-primary">
                  <i className="fas fa-download"></i> Download Follow The Mouse Lua Script
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
